import { DropdownOptionModel } from './dropdown-option-model';

const values: DropdownOptionModel<string>[] =
  ['II', 'III', 'IV', 'V', 'Jr', 'Sr'].map(x => {
    return { value: x, display: x };
  });
export const SUFFIX_OPTIONS: DropdownOptionModel<string>[] = values;
